import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import { Financing } from './components/Financing';
import AdminPage from './pages/Admin';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Financing />,
  },
  {
    path: '/antiga',
    element: <App />,
  },
  {
    path: '/financiamento',
    element: <Financing />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
